import { useEffect, useCallback } from "react"
import { FormControl } from "@mui/material"
import { observer } from "mobx-react"
import { t } from "@lingui/macro"
import camelcaseKeys from "camelcase-keys"

import { InfoCenterAdminService } from "src/api"

import { useStore } from "src/store/lib/useStore"
import { LibraryInformationItemStore } from "src/modals/library-information-items/store"
import { reportError } from "src/lib/report"
import { AutoCompleteTextField } from "src/components/AutoCompleteTextField"

export const LibraryInformationItemsCategory = observer(() => {
    const store = useStore(LibraryInformationItemStore)

    useEffect(() => {
        ;(async () => {
            try {
                store.setCategories(
                    camelcaseKeys(
                        await InfoCenterAdminService.infocenterGetCategory(),
                    ).map((category) => ({
                        ...category,
                        rank: category.rank ?? 0,
                    })),
                )
            } catch (error) {
                reportError(
                    t`edit-information-item-modal.load-categories-fail`,
                    error,
                )
            }
        })()
    }, [store])

    const handleCategoryChange = useCallback(
        (_, option) => {
            store.formFields.set("category", Number(option.id))
        },
        [store.formFields],
    )

    return (
        <FormControl style={{ breakInside: "avoid" }}>
            <AutoCompleteTextField
                id="category"
                options={store.categoryOptions}
                value={store.getSelectedCategory(
                    store.formFields.get("category"),
                )}
                onChange={handleCategoryChange}
                label={t`edit-information-item-modal.category`}
                error={Boolean(store.formFields.error("category"))}
                helperText={store.formFields.error("category") ?? undefined}
                disabled={store.formFields.get("accessType") === "READ"}
                disableClearable
            />
        </FormControl>
    )
})
